@if (loaderIcon | async) {
<app-loader></app-loader>
}
<div class="border p-3 rounded shadow-sm mb-2">
  <div class="row g-2 align-items-center">
    <div class="col-lg-5">
      <div class="row">
        <div class="col-6">
          <p class="mb-1"><strong>{{'Vendor ID : ' | wordReplace}}</strong>{{vendorInfo?.MarketVendorId}}</p>
          <p class="mb-1"><strong>Name :</strong> {{vendorInfo?.VendorName}}</p>
        </div>
        <div class="col-6">
          <p class="mb-1"><strong>Phone :</strong> {{vendorInfo?.Telephone | phoneFormat}}</p>
          <p class="mb-1"><strong>Email :</strong> {{vendorInfo?.Email}}</p>
        </div>
      </div>
    </div>
    <div class="col-lg-7 d-flex align-items-center gap-2"></div>
  </div>
</div>
<div class="bg-white rounded">
  <form [formGroup]="discountPlanForm">
    <div class="discount-box shadow-sm">
      <div class="row d-flex align-items-center gap-3">
        <div class="col-md-5">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="applyDiscount" formControlName="DiscountAll">
            <label for="applyDiscount" class="form-check-label flex-grow-1">
              Apply Discount on all items on all days (%)
            </label>
          </div>
        </div>
        <div class="col-md-3 mt-2">
          <input type="text" class="form-control" formControlName="DiscountAllPercent" appPercentageFormatter
            value="0.00%" />
        </div>
      </div>
    </div>

    <div class="discount-box mt-2 shadow-sm">
      <h6 class="fw-bold mb-3">Upto 5 Discount plans can be created here</h6>
      <div class="row align-items-center mb-3">
        <div class="col-md-2">
          <label class="form-label">Plan ID</label>
          <input type="text" class="form-control" formControlName="PlanId">
        </div>

        <div class="col-md-auto text-center">
          <label class="form-label d-block">Apply to all Days of Weeks</label>
          <div class="form-check d-inline-block me-2">
            <input class="form-check-input" type="checkbox" id="applyAllDays" formControlName="All">
          </div>
        </div>
        <div class="col-md-auto text-center alignDays">
          <div class="d-flex justify-content-center" style="gap: 1.8rem !important;">
            <div class="text-center">
              <div class="day-label">Sun</div>
              <input class="form-check-input mt-2" type="checkbox" formControlName="Sun">
            </div>
            <div class="text-center">
              <div class="day-label">Mon</div>
              <input class="form-check-input mt-2" type="checkbox" formControlName="Mon">
            </div>
            <div class="text-center">
              <div class="day-label">Tue</div>
              <input class="form-check-input mt-2" type="checkbox" formControlName="Tue">
            </div>
            <div class="text-center">
              <div class="day-label">Wed</div>
              <input class="form-check-input mt-2" type="checkbox" formControlName="Wed">
            </div>
            <div class="text-center">
              <div class="day-label">Thu</div>
              <input class="form-check-input mt-2" type="checkbox" formControlName="Thu">
            </div>
            <div class="text-center">
              <div class="day-label">Fri</div>
              <input class="form-check-input mt-2" type="checkbox" formControlName="Fri">
            </div>
            <div class="text-center">
              <div class="day-label">Sat</div>
              <input class="form-check-input mt-2" type="checkbox" formControlName="Sat">
            </div>
          </div>
        </div>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label">Plan Name<span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="PlanName" maxlength="50">
          </div>
          <div class="col-md-2">
            <label class="form-label">From<span class="text-danger">*</span></label>
            <ejs-datepicker class="form-control p-0" formControlName="EffectiveFrom" format="MM/dd/yyyy" [min]="today"
              (change)="onStartDateChange($event)">
            </ejs-datepicker>
          </div>
          <div class="col-md-2">
            <label class="form-label">To<span class="text-danger">*</span></label>
            <ejs-datepicker class="form-control p-0" formControlName="ExpiryDate" format="MM/dd/yyyy"
              [min]="minExpiryDate">
            </ejs-datepicker>
          </div>
          <div class="col-md-2">
            <label class="form-label">Discount %<span class="text-danger">*</span></label>
            <input type="text" class="form-control" formControlName="DiscountPercent" appPercentageFormatter
              value="0.00%">
          </div>
        </div>
        <div class="text-end mt-3">
          <button class="btn btn-dark px-4 me-2" (click)="addDiscountPlan()"
            [disabled]="discountPlanForm.get('DiscountAll')?.value">
            {{ selectedPlanId ? 'Update' : 'Add' }}
          </button>
          <button *ngIf="selectedPlanId" class="btn btn-danger px-4 me-2" (click)="deleteDiscountPlan(selectedPlanId)"
            [disabled]="discountPlanForm.get('DiscountAll')?.value || !selectedPlanId">
            Delete
          </button>
          <button class="btn btn-secondary px-4" (click)="cancelEdit()"
            [disabled]="discountPlanForm.get('DiscountAll')?.value">
            Cancel
          </button>
        </div>
      </div>

      <ejs-grid [dataSource]="allData" [allowPaging]="false" [allowSorting]="false" height="150"
        (rowSelected)="onRowSelected($event)">
        <e-columns>
          <e-column field="PlanId" headerText="Plan ID" width="100"></e-column>
          <e-column field="PlanName" headerText="Plan Name" width="200"></e-column>
          <e-column field="EffectiveFrom" headerText="Start Date" width="120" type="date" format="MM/dd/yyyy">
          </e-column>
          <e-column field="ExpiryDate" headerText="End Date" width="120" type="date" format="MM/dd/yyyy">
          </e-column>
          <e-column field="DiscountPercent" headerText="Discount %" width="110" format="N2"></e-column>

          <ng-container *ngFor="let day of days">
            <e-column [field]="day.field" [headerText]="day.label" width="70" textAlign="Center">
              <ng-template #template let-data>
                <i class="bi bi-check-square-fill text-warning" *ngIf="data[day.field]"></i>
                <i class="bi bi-square" *ngIf="!data[day.field]"></i>
              </ng-template>
            </e-column>
          </ng-container>
        </e-columns>
      </ejs-grid>
    </div>
    <div class="row">
      <div class="col-12 text-md-end my-2">
        <button class="btn btnAS me-2" type="button" (click)="saveDiscountPlans()">
          Save
        </button>
        <button class="btn btn-orange" type="button" (click)="onCancel()">Cancel</button>
      </div>
    </div>
  </form>
</div>